import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import {
  colorMap,
  positionMap,
  alignmentMap,
  styleMap,
  getLinkFromRef,
  getLinkListFromApi,
  getLink,
  isLocal,
  isCms,
  getLocalPath,
  getUrlParameter,
  isScreenSmall,
  isBannerTypeOf,
} from '../../utility'

import { fetchData } from '../../data'

import { IconText } from '..'
import '../../../components/EmailSubscriptionCenter/Modal'

import { BannerComplex } from './bannerComplex.jsx'
import { BannerProduct } from './bannerProduct.jsx'
import { BannerVideo } from './bannerVideo.jsx'

import './banner.css'

export function Banner({ page, component, item, params, banner }) {
  const searchParamId =
    component?.model?.name === 'Banner2' ? getUrlParameter('id') : null

  const [isPlaying, setIsPlaying] = useState(false)

  const [bannerType, setBannerType] = useState(banner || null)

  const [apiDocument, setApiDocument] = useState()

  const [parameters, setParameters] = useState({
    alignment: null,
    style: null,
    backgroundColor: null,
    position: null,
    bannerType: null,
    derived: {
      isCallout: null,
      isQuote: null,
    },
    marginTop: null,
    marginBottom: null,
  })

  const [styles, setStyles] = useState({
    backgroundColor: null,
    textColor: null,
    textBackgroundColor: null,
    secondaryColor: null,
    contentColor: null,
    buttonClass: null,
    padding: null,
    absolute: null,
    position: null,
    position2: null,
    outerSize: null,
    innerSize: null,
    imageSize: null,
    videoSize: null,
    subtitleSize: null,
    outerBackground: null,
    leftPosition: null,
    rightPosition: null,
    alignment: null,
    textAlign: null,
    hover: null,
    arrow: null,
  })

  const [blurb, setBlurb] = useState({
    id: null,
    document: null,
    title: null,
    subtitle: null,
    publicationDate: null,
    html: null,
    imageUrl: null,
    imageDescription: null,
    time: null,
    keys: null,
    videoId: null,
    itemType: null,
    link: null,
    linkList: null,
    subscriptionCenter: null,
  })

  useEffect(() => {
    const _parameters = params || component?.getParameters()
    const _models = component?.getModels() || {}
    const { document: _documentRef } = _models
    const _document = _documentRef && page.getContent(_documentRef)
    setParameters({
      ..._parameters,
      derived: {
        ..._parameters.derived,
        isCallout:
          _parameters.style === 'Callout' ||
          _parameters.style === 'Quote' ||
          _parameters.style === 'VideoBlog',
        isSubheadingAbove: _parameters.style === 'Subheading Above',
        isQuote: _parameters.style === 'Quote',
      },
      marginTop: _parameters.derived?.isList
        ? 'No Spacing'
        : _parameters.marginTop || 'No Spacing',
      marginBottom: _parameters.derived?.isList
        ? 'No Spacing'
        : _parameters.marginBottom || 'No Spacing',
    })

    setStyles({
      ...colorMap[_parameters.backgroundColor || 'None'],
      ...positionMap[_parameters.position || 'None'],
      ...alignmentMap[_parameters.alignment || 'Left'],
      ...styleMap[
        _parameters.style
          ? _parameters.derived?.isList
            ? _parameters.style + 'InList'
            : _parameters.style
          : 'None'
      ],
    })

    if (item) {
      setBlurb(item)
    } else if (!searchParamId) {
      const translatedData = {}

      if (_document) {
        const data = _document.getData()
        translatedData.title = data.title
        translatedData.subtitle = data.subtitle || data.subhead
        translatedData.publicationDate = data.publicationDate
        translatedData.html =
          data.html && typeof data.html === 'object'
            ? data.html?.value
            : data.html || data.content
        translatedData.imageRef = data.image || data.heroImage
        translatedData.time = data.time
        translatedData.keys = data.keys
        translatedData.videoId = data.videoId
        translatedData.itemType = data.itemType
        translatedData.link = data.linkCompound
        translatedData.linkList = data.linkList
        const subscriptionTypeDocument = page.getContent(
          _document.getData()?.authorSubscription?.$ref?.split('/')[2]
        )?.model?.data
        translatedData.subscriptionCenter = {
          active: subscriptionTypeDocument?.status,
          name: subscriptionTypeDocument?.displayName,
        }
      }

      const {
        title,
        subtitle,
        publicationDate,
        html,
        imageRef,
        time,
        keys,
        videoId,
        itemType,
        link,
        linkList,
        subscriptionCenter,
      } = translatedData

      const image = imageRef && page?.getContent(imageRef)

      const imageUrl = image?.getOriginal()?.getUrl()
      const imageDescription = image?.getDescription()

      setBlurb({
        id: null,
        document: _document,
        title: title,
        subtitle: subtitle,
        publicationDate: publicationDate,
        html: html,
        imageUrl: imageUrl,
        imageDescription: imageDescription,
        time: time,
        keys: keys,
        videoId: videoId,
        itemType: itemType,
        link: getLink(getLinkFromRef(link, page), null),
        linkList: linkList?.links
          ?.filter((l) => l.link && l.link.length > 0)
          .map((l) => getLink(getLinkFromRef(l, page), null)),
        subscriptionCenter: subscriptionCenter,
      })
    }

    if (!banner) {
      if (_parameters.bannerType) {
        setBannerType(_parameters.bannerType)
      } else if (blurb.videoId) {
        setBannerType('video')
      } else {
        setBannerType('complex')
      }
    }
  }, [page, component, component?.model, item, params])

  useEffect(() => {
    if (!searchParamId) {
      setApiDocument(null)
    }

    if (item) {
      return
    }

    if (
      searchParamId &&
      (!apiDocument || apiDocument?.url?.indexOf(searchParamId) < 0)
    ) {
      const documentUrl = `${getLocalPath()}/halapi/documents/${searchParamId}`
      setApiDocument({ url: documentUrl })
    }
  }, [page, component])

  useEffect(() => {
    if (!searchParamId) {
      setApiDocument(null)
    }

    if (apiDocument && apiDocument.url && !apiDocument.payload) {
      const fetchAsync = async () => {
        const data = await fetchData(apiDocument.url)
        if (data) {
          setApiDocument({ url: apiDocument.url, payload: data })
        }
      }

      fetchAsync()
    }
  }, [apiDocument])

  useEffect(() => {
    if (apiDocument && apiDocument.payload) {
      const data = apiDocument.payload
      const imageUrl = data['image']?.['_meta']?.['mirror']?.['path']
      setBlurb((blurb) => ({
        ...blurb,
        id: data['_meta']['id'],
        title: data['title'],
        subtitle: data['subtitle'],
        publicationDate:
          data['publicationDate'] < 0 ? null : data['publicationDate'],
        html: data['html']['content'],
        imageUrl: imageUrl
          ? `${isLocal() || isCms() ? '/cti-site' : ''}/binaries/${imageUrl}`
          : '',
        time: data['time'],
        keys: data['keys'],
        videoId: data['videoId'],
        itemType: data['itemType'],
        link: null,
        linkList: getLinkListFromApi(
          data['LinkList']?.links?.filter((l) => l.Link && l.Link.length > 0)
        ),
      }))

      const imageId = data['image']?.['_meta']?.['mirror']?.['id']
      if (imageId) {
        fetchData(
          `${getLocalPath()}/halapi/documents/${imageId}?_fields=description`
        ).then((result) => {
          setBlurb((blurb) => ({
            ...blurb,
            imageDescription: result?.description,
          }))
        })
      }

      if (data['authorSubscription']) {
        fetchData(
          `${getLocalPath()}/halapi/documents/${data.authorSubscription}`
        ).then((result) => {
          setBlurb((blurb) => ({
            ...blurb,
            subscriptionCenter: {
              active: result?.status,
              name: result?.name,
            },
          }))
        })
      }
    }
  }, [apiDocument])

  const renderIcons = () => {
    return (
      <>
        {blurb.itemType && blurb.itemType !== 'Video list' && (
          <IconText
            icon={blurb.itemType}
            text={blurb.itemType}
            textColor={styles.textColor}
            iconColor={styles.textColor}
          />
        )}
        {blurb.time && (
          <IconText
            className={
              blurb.itemType && blurb.itemType !== 'Video list'
                ? 'u-marginLeft4gu'
                : ''
            }
            icon={blurb.time}
            text={blurb.time}
            textColor={styles.textColor}
            iconColor={
              blurb.itemType === 'Video list'
                ? 'u-textColorBrandLight'
                : styles.textColor
            }
          />
        )}
        {blurb.keys?.indexOf('client-materials') > -1 && (
          <IconText
            className={blurb.time || blurb.itemType ? 'u-marginLeft4gu' : ''}
            icon={'Client materials'}
            text={'Client materials'}
            textColor={styles.textColor}
            iconColor={styles.textColor}
          />
        )}
      </>
    )
  }

  const hasVisualMedia = blurb?.videoId || blurb?.imageUrl

  const _HEIGHT =
    parameters.position === 'Top Angled'
      ? 550
      : (blurb.title || blurb.subtitle) &&
          (blurb.html || blurb.link?.url || blurb.link?.href) &&
          (!parameters.derived?.isList || isPlaying || isScreenSmall()) &&
          (!isBannerTypeOf(bannerType, 'product') || hasVisualMedia)
        ? 400
        : blurb.imageUrl && parameters.style === 'Icon'
          ? 300
          : !isBannerTypeOf(bannerType, 'product')
            ? 240
            : blurb.linkList?.length > 0
              ? 150
              : 80

  const bannerProps = {
    page: page,
    parameters: parameters,
    styles: styles,
    blurb: blurb,
    height: _HEIGHT,
    bannerType: bannerType,
    setStyles: setStyles,
    renderIcons: renderIcons,
    setIsPlaying: setIsPlaying,
    isPlaying: isPlaying,
    hasVisualMedia: hasVisualMedia,
  }

  const getBannerType = (bannerType) => {
    switch (bannerType) {
      case 'complex':
        return <BannerComplex {...bannerProps} />
      case 'product':
        return <BannerProduct {...bannerProps} />
      case 'video':
        return <BannerVideo {...bannerProps} />
      default:
        return <BannerComplex {...bannerProps} />
    }
  }

  return (
    <div data-interaction-studio="IS010-2" className="interaction-studio">
      {bannerType ? getBannerType(bannerType) : null}
    </div>
  )
}

Banner.propTypes = {
  page: PropTypes.object.isRequired,
  component: PropTypes.object,
  item: PropTypes.object,
  params: PropTypes.object,
  banner: PropTypes.string,
}
